import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';



export default class OpenArrow extends React.Component {

    public props: any;

    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <FontAwesomeIcon   
            icon="chevron-right"
            color={this.props.color}
            rotation={ this.props.open ?
                90 : 270
            }
            transform="shrink-2"
            style={{marginRight: '10px'}}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/OpenArrow/OpenArrow.tsx